import React from 'react'

import { FormattedMessage } from 'react-intl'
import {
  Button,
  ButtonSet,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Text,
} from '@indeed/ifl-components'
import { LoginTroubleModalProps as Props } from './LoginTroubleModal.types'

const LoginTroubleModal = ({ isOpen, handleOnExit, handleSubmit }: Props) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => handleOnExit()} data-testid="login-trouble-modal">
      <DialogContent>
        <DialogHeader>Confirmation</DialogHeader>
        <DialogBody>
          <Text as="p" level={3}>
            If you are having trouble logging in, you could try doing a full reset of cached data.
          </Text>
          <Text as="p" level={3}>
            Close all other <FormattedMessage id="brand.name" /> ACP windows, then click "OK" to clear the
            data and reload the page. You can then try logging in again.
          </Text>
        </DialogBody>
        <DialogFooter>
          <ButtonSet>
            <Button variant="secondary" onClick={handleOnExit}>
              Close
            </Button>
            <Button onClick={handleSubmit}>Ok</Button>
          </ButtonSet>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default LoginTroubleModal
